<template>
    <a @click.prevent="$emit('click')" :class="{
        [`relative z-10 flex items-center cursor-pointer border-2 rounded-lg p-4`]: true,
        [`border-${$root.theme}-400`]: selected,
    }">
        <p v-if="discount" class="absolute -top-2.5 text-xxs font-medium bg-yellow-100 rounded-lg py-0.5 px-1.5">Most Popular</p>
        <div class="flex-initial">
            <svg v-if="! selected" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                 class="w-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
            </svg>
            <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" :class="`w-6 text-${$root.theme}-400`">
                <path fill-rule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z" clip-rule="evenodd" />
            </svg>
        </div>
        <div class="flex-row space-y-0.5 ml-4">
            <p class="text-gray-500 text-sm font-medium" v-text="discount ? 'Discount Balance' : 'Original Balance'" />
            <div class="flex space-x-2">
                <p class="flex-initial font-bold text-black">${{ amount.toFixed(2) }}</p>
                <div v-if="discount" :class="`px-1.5 py-1 font-medium rounded text-xs bg-${$root.theme}-100 text-${$root.theme}-400`">
                    {{ discountPercent }}% off, Save ${{ discountAmount.toFixed(0) }}
                </div>
            </div>
        </div>
    </a>
</template>

<script>
    export default {
        props: {
            selected: Boolean,
            discount: Boolean,
            total: Number,
            amount: Number,
        },

        computed: {
            discountAmount() {
                return this.total - this.amount;
            },

            discountPercent() {
                return ((this.total - this.amount) / this.total) * 100;
            }
        }
    }
</script>
